// extracted by mini-css-extract-plugin
export default {"screen-slider":"screen-slider--Gizjz","screenSlider":"screen-slider--Gizjz","blink":"blink--iqnCQ"};